<div class="bulk-payment-wizard">
  <!-- Progress indicator -->
  <div class="wizard-progress">
    <div
      class="progress-step"
      [class.active]="currentStep >= BulkPaymentStep.UPLOAD"
      [class.completed]="currentStep > BulkPaymentStep.UPLOAD"
    >
      <div class="step-number">1</div>
      <div class="step-label">Upload</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > BulkPaymentStep.UPLOAD"></div>
    <div
      class="progress-step"
      [class.active]="currentStep >= BulkPaymentStep.COLUMN_MAPPING"
      [class.completed]="currentStep > BulkPaymentStep.COLUMN_MAPPING"
    >
      <div class="step-number">2</div>
      <div class="step-label">Map Columns</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > BulkPaymentStep.COLUMN_MAPPING"></div>
    <div
      class="progress-step"
      [class.active]="currentStep >= BulkPaymentStep.REVIEW"
      [class.completed]="currentStep > BulkPaymentStep.REVIEW"
    >
      <div class="step-number">3</div>
      <div class="step-label">Review</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > BulkPaymentStep.REVIEW"></div>
    <div
      class="progress-step"
      [class.active]="currentStep >= BulkPaymentStep.PROCESS"
      [class.completed]="currentStep > BulkPaymentStep.PROCESS"
    >
      <div class="step-number">4</div>
      <div class="step-label">Process</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > BulkPaymentStep.PROCESS"></div>
    <div class="progress-step" [class.active]="currentStep >= BulkPaymentStep.RESULTS">
      <div class="step-number">5</div>
      <div class="step-label">Results</div>
    </div>
  </div>

  <!-- Step content -->
  <div class="wizard-content">
    <!-- Step 1: Upload -->
    @if (currentStep === BulkPaymentStep.UPLOAD) {
    <div class="step-container">
      <h3>Step 1: Upload CSV File</h3>
      <p class="step-description">Upload a CSV file containing payment information.</p>
      <app-bulk-payment-upload-step
        [initialFileName]="uploadedFileName"
        [initialRowCount]="uploadedRowCount"
        (csvUploaded)="onCsvUploaded($event)"
        (csvCleared)="onCsvCleared()"
      ></app-bulk-payment-upload-step>
    </div>
    }

    <!-- Step 2: Column Mapping -->
    @if (currentStep === BulkPaymentStep.COLUMN_MAPPING) {
    <div class="step-container">
      <h3>Step 2: Map Your Columns</h3>
      <p class="step-description">Tell us which columns contain the account number, amount, and invoice number.</p>
      <app-bulk-payment-column-mapping-step
        [rawData]="rawCsvData"
        (mappingChange)="onColumnMappingChange($event)"
      ></app-bulk-payment-column-mapping-step>
    </div>
    }

    <!-- Step 3: Review -->
    @if (currentStep === BulkPaymentStep.REVIEW) {
    <div class="step-container">
      <h3>Step 3: Review Matched Customers</h3>
      @if (isMatching) {
      <div class="loading-state">
        <mat-icon>hourglass_empty</mat-icon>
        <p>Matching customers...</p>
      </div>
      } @else {
      <app-bulk-payment-review-step
        [matches]="matches"
        [costOfCapitalPercent]="costOfCapitalPercent"
        [applyCostOfCapital]="applyCostOfCapital"
        (costOfCapitalChange)="onCostOfCapitalChange($event)"
        (addCustomer)="onAddCustomer($event)"
        (selectCustomer)="onSelectCustomer($event)"
        (selectPaymentMethod)="onSelectPaymentMethod($event)"
        (addCard)="onAddCard($event)"
        (amountEdited)="onAmountEdited($event.match, $event.rawAmount)"
        (invoiceEdited)="onInvoiceEdited($event.match, $event.rawInvoice)"
      ></app-bulk-payment-review-step>
      }
    </div>
    }

    <!-- Step 4: Process -->
    @if (currentStep === BulkPaymentStep.PROCESS) {
    <div class="step-container">
      <h3>Step 4: Processing Payments</h3>
      <app-bulk-payment-process-step
        [isProcessing]="isProcessing"
        [progress]="processingProgress"
        [matchedCount]="matchedCount"
      ></app-bulk-payment-process-step>
    </div>
    }

    <!-- Step 5: Results -->
    @if (currentStep === BulkPaymentStep.RESULTS) {
    <div class="step-container">
      <h3>Step 5: Results</h3>
      <app-bulk-payment-results-step
        [results]="results"
        [matches]="matches"
        (downloadResults)="downloadResults()"
        (viewReceipt)="viewReceipt($event)"
        (downloadReceipt)="downloadReceipt($event)"
      ></app-bulk-payment-results-step>
    </div>
    }
  </div>

  <!-- Navigation buttons -->
  <div class="wizard-actions">
    @if (currentStep === BulkPaymentStep.UPLOAD) {
    <button
      mat-raised-button
      color="primary"
      (click)="proceedToColumnMapping()"
      [disabled]="!canProceedToColumnMapping"
    >
      Next: Map Columns
      <mat-icon>arrow_forward</mat-icon>
    </button>
    } @if (currentStep === BulkPaymentStep.COLUMN_MAPPING) {
    <button mat-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <button
      mat-stroked-button
      class="apply-mapping-btn"
      (click)="applySavedMapping()"
      [disabled]="!hasSavedMapping"
      title="{{ hasSavedMapping ? 'Apply your previously saved column mapping' : 'No saved mapping for this profile yet' }}"
    >
      <mat-icon>restore</mat-icon>
      Apply Saved Mapping
    </button>
    <button
      mat-stroked-button
      class="save-mapping-btn"
      (click)="saveColumnMapping()"
      [disabled]="!canProceedToReview || isSavingMapping"
    >
      <mat-icon>save</mat-icon>
      {{ isSavingMapping ? 'Saving...' : 'Save Mapping' }}
    </button>
    <button
      mat-stroked-button
      class="export-mapping-btn"
      (click)="openExportMapping()"
    >
      <mat-icon>file_download</mat-icon>
      Export Mapping
    </button>
    <button
      mat-stroked-button
      class="import-mapping-btn"
      (click)="openImportMapping()"
    >
      <mat-icon>file_upload</mat-icon>
      Import Mapping
    </button>
    <button mat-raised-button color="primary" (click)="proceedToReview()" [disabled]="!canProceedToReview">
      Next: Review Matches
      <mat-icon>arrow_forward</mat-icon>
    </button>
    } @if (currentStep === BulkPaymentStep.REVIEW) {
    <button mat-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <button mat-raised-button color="primary" (click)="proceedToProcess()" [disabled]="!canProceedToProcess">
      Process Payments ({{ matchedCount }})
      <mat-icon>arrow_forward</mat-icon>
    </button>
    } @if (currentStep === BulkPaymentStep.RESULTS) {
    <button mat-button (click)="reset()">
      <mat-icon>refresh</mat-icon>
      Process Another Batch
    </button>
    <button mat-raised-button color="primary" (click)="downloadResults()">
      <mat-icon>download</mat-icon>
      Download Results
    </button>
    }
  </div>
</div>
